import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles({
  companyLogo: {
    borderRadius: '4px',
    border: `1px solid ${colors.gray.l85}`,
    overflow: 'hidden',
    height: 'fit-content',
  },
  fullWidthContainer: {
    width: '100%',
  },
  listingFont: {
    fontWeight: 500,
    fontSize: '14px',
    color: colors.gray.l45,
  },
  profileInfo: {
    overflow: 'hidden',
    width: '100%',
  },
  profileUpperSection: {
    padding: '24px 24px 16px 24px',
  },
});
